import React, { useEffect } from "react";
import "./index.scss";
import { Col, Row, Table, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { getBidProduct, getResultsProduct } from "dataLayer/product";
import { useQuery } from "react-query";
import { PATHS } from "@config/constants";
import moment from "moment";
import { DATE_TIME_FORMAT_MONTH_ONLY } from "@config/constants/_date-time";

const { Title, Paragraph, Link } = Typography;
const TermsPage = () => {
  const { data: products } = useQuery(getBidProduct());
  const { data: results } = useQuery(getResultsProduct());
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("title.terms");
  }, [t]);

  const pack = [
    {
      title: "Suscripción",
      dataIndex: "package",
    },
    {
      title: "Precio (inc. IGV)",
      dataIndex: "fee",
    },
    {
      title: "Cantidad de Pujas",
      dataIndex: "bid",
    },
    {
      title: "Vigencia",
      dataIndex: "duration",
    },
  ];

  const packageData = [
    {
      package: "Diaria",
      fee: "S/ 1.80",
      bid: "2",
      duration: "1 día",
    },
    {
      package: "Semanal",
      fee: "S/ 3.99",
      bid: "5",
      duration: "7 días",
    },
    {
      package: "Mensual",
      fee: "S/ 6.99",
      bid: "20",
      duration: "30 días",
    },
  ];

  const chance = [
    {
      title: "Nombre de paquete extra",
      dataIndex: "package",
    },
    {
      title: "Precio (inc. IGV)",
      dataIndex: "fee",
    },
    {
      title: "Cantidad de Pujas",
      dataIndex: "bid",
    },
    {
      title: "Vigencia",
      dataIndex: "duration",
    },
  ];

  const chanceData = [
    {
      package: "Chance",
      fee: "S/ 1.00",
      bid: "1",
      duration: "12 meses",
    },
    {
      package: "Chance2",
      fee: "S/ 2.00",
      bid: "2",
      duration: "12 meses",
    },
    {
      package: "Chance5",
      fee: "S/ 5.00",
      bid: "5",
      duration: "12 meses",
    },
    {
      package: "Chance10",
      fee: "S/ 10.00",
      bid: "10",
      duration: "12 meses",
    },
  ];

  const upcoming = [
    {
      title: "DETALLE",
      dataIndex: "detail",
    },
    {
      title: "Stock",
      dataIndex: "stock",
    },
  ];

  const result = [
    {
      title: "DETALLE",
      dataIndex: "detail",
    },
    {
      title: "Cantidad",
      dataIndex: "quality",
    },
    {
      title: "Mes subastado",
      dataIndex: "endtime",
    },
  ];

  const sortedProducts = products?.sort(
    (a, b) => Date.parse(a?.start_time) - Date.parse(b?.start_time)
  );
  const data_premios = sortedProducts?.map((product) => ({
    detail: product?.product_name,
    stock: "1",
  }));

  const sortedResults = results?.sort(
    (a, b) => Date.parse(a?.start_time) - Date.parse(b?.start_time)
  );
  const data_results = sortedResults?.map((result) => ({
    detail: result?.product_name,
    quality: "1",
    endtime: moment(result?.start_time).format(DATE_TIME_FORMAT_MONTH_ONLY),
  }));

  return (
    <div className="rules-page">
      <div className="rules-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            {/* <Title level={2} className="rules-page-title">{t("terms")}</Title> */}
            <Title level={2} className="rules-page-title">
              TÉRMINOS Y CONDICIONES DEL SERVICIO “SUBASTAS”
            </Title>

            <div className="rules-page-content">
              <Typography>
                <Title level={2}>
                  1. <u>INTRODUCCIÓN</u>
                </Title>
                <Paragraph>
                  El acceso y uso de este sitio web se rige por los Términos y
                  Condiciones descritos a continuación. Los Términos y
                  Condiciones contenidos en este documento se aplicarán y se
                  entenderá que forman parte de todos los actos y contratos que
                  se ejecuten o celebren mediante los sistemas de oferta y
                  comercialización comprendidos en este sitio web entre los
                  usuarios de estos sitios y VIETTEL PERU S.A.C. (en adelante,
                  “Bitel”; “la Empresa” y/o “el Proveedor”).
                </Paragraph>
                <Paragraph>
                  Los presentes Términos y Condiciones contienen toda la
                  información relacionada al servicio “Subastas” (en adelante,
                  “el Servicio” y/o “Subastas”).
                </Paragraph>
                <Paragraph>
                  Para el uso del Servicio, se requiere que el cliente -de forma
                  previa- lea toda la información de nuestros Términos y
                  Condiciones. Asimismo, se deberá tener en cuenta que el
                  presente documento es un acuerdo entre Bitel y el cliente, por
                  lo que es importante que el cliente lea y entienda en su
                  totalidad los presentes Términos y Condiciones.
                </Paragraph>
                <Paragraph>
                  Al usar, acceder y registrarse para utilizar el Servicio, el
                  cliente manifiesta estar de acuerdo y acepta cumplir estos
                  Términos y Condiciones.
                </Paragraph>
                <Paragraph>
                  Bitel se reserva el derecho de actualizar y/o modificar los
                  Términos y Condiciones que detallamos a continuación en
                  cualquier momento, sin previo aviso. Por esta razón,
                  recomendamos revisar los Términos y Condiciones antes de cada
                  registro, uso o ingreso al Servicio o cada vez que se visite
                  el sitio web de Subastas. Realizaremos nuestros mejores
                  esfuerzos para asegurar la disponibilidad, sin interrupciones,
                  de los servicios de la presente página web, así como en la
                  ausencia de errores en cualquier transmisión de información
                  que pudiera tener lugar. No obstante, y debido a la naturaleza
                  misma del internet, no es posible garantizar tales extremos.
                </Paragraph>
                <Paragraph>
                  Asimismo, el acceso al Servicio podría ocasionalmente verse
                  suspendido o restringido a efectos de la realización de
                  trabajos de reparación o mantenimiento, o la introducción de
                  nuevos productos o servicios. Procuraremos limitar la
                  frecuencia y duración de tales suspensiones o restricciones.
                </Paragraph>
                <Paragraph>
                  El uso del Servicio genera consumo de data (internet).
                </Paragraph>
                <Title level={2}>
                  2. <u>CONDICIONES DEL SERVICIO</u>
                </Title>
                <Paragraph>
                  <Paragraph>
                    Las condiciones para acceder y participar en el servicio son
                    las siguientes:
                  </Paragraph>
                  <Paragraph style={{ paddingLeft: 20 }}>
                    (i) Ser abonados de Bitel con líneas móviles Prepago,
                    Postpago y/o Control activas bidireccionalmente, es decir,
                    que puedan realizar y recibir llamadas.
                  </Paragraph>
                  <Paragraph style={{ paddingLeft: 20 }}>
                    (ii) Contar con una (1) sola cuenta en el Servicio por
                    persona, independientemente del número de líneas móviles que
                    tenga el cliente bajo su titularidad. De incumplir lo antes
                    mencionado, las ofertas/pujas realizadas por el cliente no
                    serán válidas.
                  </Paragraph>
                </Paragraph>
                <Title level={2}>
                  3. <u>REGISTRO Y SUSCRIPCIÓN DEL SERVICIO</u>
                </Title>
                <ul>
                  <li>
                    <Paragraph>Suscripción a través de SMS:</Paragraph>
                    <Paragraph>
                      En caso los clientes deseen acceder al Servicio vía SMS,
                      deberán estar suscritos o suscribirse enviando la palabra
                      “SUBASTA” para la suscripción diaria, “SUBASTA7” para la
                      suscripción semanal y “SUBASTA30” para la suscripción
                      mensual al 23001 y seguir las instrucciones.
                    </Paragraph>
                  </li>
                  <li>
                    <Paragraph>
                      Registro y suscripción a través de la página web:
                    </Paragraph>
                    <Paragraph>
                      En caso los clientes deseen acceder al Servicio a través
                      de la página web{" "}
                      <Link href="https://subasta.bitel.com.pe" underline>
                        https://subasta.bitel.com.pe
                      </Link>
                      , primero deberán ingresar con su número Bitel y su
                      contraseña de “Bitel ID”/”Mi Bitel” (contraseña que se
                      utiliza para ingresar al App Mi Bitel). En caso el cliente
                      no esté registrado en “Bitel ID”, deberá hacer click en la
                      opción “Haz click aquí para registrarte” y será redirigido
                      a “Bitel ID” para registrarse. Una vez registrado, podrá
                      iniciar sesión con su número Bitel y su contraseña de
                      “Bitel ID”. Finalmente, deberá elegir la suscripción de su
                      preferencia: Diaria, Semanal o Mensual.
                    </Paragraph>
                  </li>
                </ul>
                <Title level={2}>
                  4. <u>DESCRIPCIÓN DEL SERVICIO</u>
                </Title>
                <Paragraph>
                  El Servicio es un juego interactivo diseñado e inspirado en
                  los programas de subastas donde el cliente con la oferta/puja
                  con el precio más bajo, único y válido gana el premio. Para
                  que la oferta/puja sea válida, debe estar entre los valores
                  detallados en el numeral 5, de estos Términos y Condiciones.
                </Paragraph>
                <Paragraph>
                  Después de suscribirse en el Servicio, los clientes podrán
                  participar todos los días en la subasta de los productos
                  ofrecidos siempre y cuando cuenten con pujas disponibles. El
                  ganador recibirá como premio el producto subastado.
                </Paragraph>
                <Paragraph>
                  Para poder tener pujas y poder jugar, los usuarios deben de
                  tener una suscripción en el Servicio. Los productos de subasta
                  están sujetos a cambios de una sesión a otra sesión (fechas).
                  Estos cambios serán debidamente comunicados a los jugadores.
                </Paragraph>
                <Paragraph>
                  La sesión de la subasta inicia cada domingo a las 08:00 a.m. y
                  termina el sábado siguiente a las 02:00 p.m. Los jugadores no
                  pueden participar en la subasta fuera del horario establecido.
                </Paragraph>
                <Title level={2}>
                  5. <u>INSTRUCCIONES PARA PODER PARTICIPAR EN EL SERVICIO</u>
                </Title>
                <Paragraph>
                  <li>
                    Para participar en la Subasta, el cliente deberá suscribirse
                    al Servicio, comprar paquetes extra o haber recibido una
                    puja gratis.
                  </li>
                  <li>
                    El cliente deberá contar con una (1) sola cuenta en el
                    Servicio, independientemente del número de líneas móviles
                    que tenga bajo su titularidad. De incumplir lo antes
                    mencionado, las ofertas/pujas realizadas por el cliente no
                    serán válidas.
                  </li>
                  <li>
                    En el supuesto que un cliente haya resultado ganador
                    vulnerando los presentes Términos y Condiciones, Bitel se
                    reserva el derecho de anular todas las ofertas/pujas
                    realizadas, por lo que, el premio será otorgado a la persona
                    que haya realizado la oferta/puja con el precio más bajo,
                    único y válido entre los participantes que hayan cumplido
                    con las condiciones establecidas en el numeral 2 del
                    presente documento.
                  </li>
                  <li>
                    Existen 3 tipos de suscripciones: Suscripción diaria
                    (Precio: S/ 1.80 inc. IGV), suscripción semanal (Precio: S/
                    3.99 inc. IGV) y suscripción mensual (Precio: S/ 6.99 inc.
                    IGV).
                  </li>
                  <Paragraph>
                    <li>
                      El cliente puede comprar paquetes extra de dos (2)
                      maneras:
                    </li>
                  </Paragraph>
                  <Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (i) A través de SMS: Enviando la palabra “chance” para
                      obtener 1 puja, “chance2” para obtener 2 pujas, “chance5”
                      para obtener 5 pujas o “chance10” para obtener 10 pujas al
                      23001.
                    </Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (ii) A través de la página web: Ingresando a{" "}
                      <Link href="https://subasta.bitel.com.pe" underline>
                        https://subasta.bitel.com.pe
                      </Link>
                      , el cliente deberá registrarse o iniciar sesión según sea
                      el caso y luego seleccionar “comprar pujas”. Al hacerlo,
                      se desplegarán las opciones de compra de paquetes extra y
                      el cliente deberá seleccionar la opción de su preferencia,
                      leer y aceptar los presentes Términos y Condiciones y la
                      Política de Protección de Datos y Privacidad de Bitel y
                      luego comprar el paquete. Seguidamente, el cliente
                      recibirá un SMS con un código de confirmación de 6
                      dígitos, el cual deberá ingresar en el pop up que le
                      aparecerá. Luego de ello, el cliente tendrá las pujas
                      compradas para comenzar a participar.
                    </Paragraph>
                  </Paragraph>
                  <Paragraph>
                    <li>
                      El cliente puede poner una oferta/puja para el producto a
                      subastarse durante una sesión definida (fecha).
                    </li>
                  </Paragraph>
                  <Paragraph>
                    <li>Hay dos formas de colocar la oferta/puja:</li>
                  </Paragraph>
                  <Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (i) A través de SMS: Para poder colocar la oferta/puja a
                      través de SMS, el cliente deberá enviar un mensaje de
                      texto al 23001 con las palabras “S [Precio de oferta]”.
                      Ejemplo: S 10, siendo 10 el precio de oferta. El código de
                      producto será informado al cliente mediante SMS (siempre
                      que la suscripción se haya realizado vía SMS).
                    </Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      El código del producto será informado al cliente a través
                      de SMS (siempre que la suscripción se haya realizado vía
                      SMS).
                    </Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (ii) A través de la página web: Ingresando a{" "}
                      <Link href="https://subasta.bitel.com.pe" underline>
                        https://subasta.bitel.com.pe
                      </Link>
                      . Para poder colocar la oferta/puja a través de la página
                      web, el cliente deberá iniciar sesión y dirigirse a la
                      sección “Haz tu oferta/puja aquí”, escribir el valor de la
                      puja y luego dar “click” en “Haz tu oferta/puja aquí”.
                    </Paragraph>
                  </Paragraph>
                  <li>
                    El valor de la oferta/puja mínima es de S/0.1 y el valor de
                    la oferta/puja máxima es de S/1000000. La moneda (S/) usada
                    en el ciclo de subasta es referencial para el juego. La
                    moneda de las ofertas/pujas no representa dinero real.
                  </li>
                  <li>
                    Un cliente solo puede colocar una oferta/puja con un máximo
                    de 1 decimal. Por ejemplo, puede colocar una oferta/puja por
                    S/ 0.8, pero no puede colocar una oferta/puja por S/ 0.87.
                  </li>
                  <li>
                    Una oferta/puja no equivale a ningún valor en específico. El
                    cliente que tenga una oferta/puja podrá colocarla por el
                    producto a subastarse con el valor que considere pertinente,
                    siempre y cuando ese valor a colocar esté comprendido entre
                    los valores detallados previamente (Entre S/0.1 y
                    S/1000000). Luego de colocar su oferta/puja, el cliente
                    recibirá un SMS donde se le comunicará si la oferta/puja que
                    realizó fue la más baja, única y válida o si no fue la más
                    baja, única y válida.
                  </li>
                </Paragraph>
                <Title level={2}>
                  6. <u>TIPOS DE SUSCRIPCIÓN Y PAQUETES EXTRA</u>
                </Title>
                <Paragraph>
                  <ul>
                    <li style={{ paddingLeft: 20 }}>
                      Existen las siguientes modalidades de suscripción:
                    </li>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (i) Suscripción diaria: Se renovará de manera diaria desde
                      la fecha de inicio de la suscripción.
                    </Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (ii) Suscripción semanal: Se renovará de manera semanal
                      desde la fecha de inicio de la suscripción.
                    </Paragraph>
                    <Paragraph style={{ paddingLeft: 20 }}>
                      (iii) Suscripción mensual: Se renovará de manera mensual
                      desde la fecha de inicio de la suscripción.
                    </Paragraph>
                    <Table
                      columns={pack}
                      dataSource={packageData}
                      pagination={false}
                      scroll={{ x: true }}
                      bordered
                      align="center"
                    />
                    <Paragraph style={{ paddingTop: 20 }}>
                      El Servicio se renovará automáticamente de acuerdo a la
                      modalidad de suscripción elegida por el cliente. Este
                      valor se descontará del saldo básico (recargas) que tenga
                      el usuario en su plan Prepago, Postpago o Control.
                    </Paragraph>
                    <Paragraph>
                      Para cancelar el Servicio, el cliente deberá enviar la
                      palabra “SALIR” al 23001.
                    </Paragraph>
                    <Paragraph>
                      <li style={{ paddingLeft: 20 }}>
                        Existen los siguientes paquetes extra:
                      </li>
                      <Paragraph>
                        El cliente puede comprar pujas sin necesidad de estar
                        suscrito al Servicio. Para ello deberá realizar una
                        recarga y siempre que exista un cobro efectivo de Bitel,
                        el cliente recibirá la siguiente cantidad de pujas, de
                        acuerdo al paquete extra adquirido:
                      </Paragraph>
                      <Table
                        columns={chance}
                        dataSource={chanceData}
                        pagination={false}
                        scroll={{ x: true }}
                        bordered
                        align="center"
                      />
                      {/* <Paragraph style={{ paddingTop: 20 }}>
                        Las pujas de los paquetes expirarán en 60 días desde la fecha de compra. Puedes revisar los detalles de la fecha de expiración de las pujas que compraste en la seccion historial de paquetes (Cuenta/Suscripción/Historial del paquete).
                      </Paragraph> */}
                    </Paragraph>
                  </ul>
                </Paragraph>
                <Title level={2}>
                  7. <u>PRODUCTOS A SUBASTAR:</u>
                </Title>
                <Table
                  columns={upcoming}
                  dataSource={data_premios}
                  pagination={false}
                  scroll={{ x: true }}
                  bordered
                  align="center"
                />
                <Title level={2}>
                  8. <u>PRODUCTOS SUBASTADOS DESDE JUNIO A LA FECHA:</u>
                </Title>
                <Table
                  columns={result}
                  dataSource={data_results}
                  pagination={false}
                  scroll={{ x: true }}
                  bordered
                  align="center"
                />
                <Title level={2}>
                  9. <u>GANADOR DE LA SUBASTA</u>
                </Title>
                <Paragraph style={{ paddingLeft: 20 }}>
                  <li>
                    El ganador de la Subasta dentro de la sesión (fecha) será
                    seleccionado por el sistema MySQL. Este sistema utiliza una
                    lógica en código duro de manera automática para elegir al
                    ganador de la subasta que cumpla con la oferta/puja más
                    baja, única y válida.
                  </li>
                  <li>
                    Habrá un ganador siempre y cuando haya un cliente que haya
                    colocado una oferta/puja más baja, única y válida durante el
                    ciclo de la subasta.
                  </li>
                  <li>
                    En caso en el ciclo de la subasta no haya una oferta/puja
                    más baja, única y válida no se declarará un ganador por ese
                    producto. Bitel podrá utilizar dicho producto para próximas
                    subastas.
                  </li>
                  <li>
                    Los clientes podrán ver quién ha sido el ganador de la
                    Subasta a través de la página web{" "}
                    <Link href="https://subasta.bitel.com.pe" underline>
                      https://subasta.bitel.com.pe
                    </Link>{" "}
                    en la sección “Resultados” o vía SMS enviando un mensaje al
                    23001 con lo siguiente: “GANADOR [Código del Producto]”.
                  </li>
                  <li>
                    Podrá haber máximo un (1) ganador por cada sesión de
                    subasta.
                  </li>
                  <li>
                    El premio a ser entregado al ganador será el mismo por el
                    que este ofertó/pujó durante el ciclo de subasta del
                    producto.
                  </li>
                  <li>
                    El ganador será contactado y confirmado al final del ciclo
                    de la subasta. Esta comunicación se realizará vía SMS.
                  </li>
                  <li>
                    El ganador recibirá un SMS donde se le indicará que es el
                    ganador de la subasta y se le informará que el departamento
                    de Atención al Cliente de Bitel (123) se contactará con él.
                  </li>
                  <li>
                    El ganador firmará un “Acta de entrega de premio”, donde una
                    copia quedará en poder del ganador y otra copia en poder de
                    Bitel.
                  </li>
                </Paragraph>
                <Title level={2}>
                  10.{" "}
                  <u>
                    PROCEDIMIENTO PARA LA SELECCIÓN, CONTACTO, Y ENTREGA DEL
                    PREMIO
                  </u>
                </Title>
                <Paragraph>
                  Una vez culminado el proceso de validación de la subasta, el área de Atención al Cliente de Bitel se comunicará telefónicamente con el cliente confirmado como ganador, a fin de validar su identidad y solicitar la información necesaria para coordinar la entrega, como nombres y apellidos completos, DNI o Carné de Extranjería, correo electrónico, domicilio y referencias.
                </Paragraph>
                <Paragraph>
                  Si el ganador no responde la llamada o su teléfono se encuentra apagado, ocupado o fuera de servicio, Bitel realizará hasta cuatro (4) intentos adicionales, a razón de una (1) llamada por día, completando un máximo de cinco (5) intentos. Si luego de dichos intentos no se logra contactar y validar al ganador, este perderá el derecho a recibir el premio, el cual retornará al inventario.
                </Paragraph>
                <Paragraph>
                  La entrega se realizará según el lugar de residencia declarado por el ganador:
                </Paragraph>
                <Paragraph style={{ paddingLeft: 20 }}>
                  <li>
                    <strong>Lima Metropolitana y Callao:</strong> El recojo se efectuará, previa coordinación, en la sede de Bitel ubicada en <strong>Dionisio Derteano N.° 144, distrito de San Isidro, piso 16</strong>, de lunes a viernes, excepto feriados y días en los que la sede no brinde atención, en los horarios de <strong>10:00 a. m. a 12:00 p. m. o de 3:00 p. m. a 5:00 p. m.</strong>
                  </li>
                  <li>
                    <strong>Provincias:</strong> El premio será entregado en el Centro de Atención Bitel o punto de entrega que Bitel comunique previamente al ganador, de acuerdo con la disponibilidad logística y los horarios de atención de la sede asignada.
                  </li>
                </Paragraph>
                <Paragraph>
                  El ganador no deberá acudir a ninguna sede sin haber recibido previamente la confirmación de la fecha, horario y lugar de entrega. Bitel podrá modificar estos datos por razones operativas, logísticas, de seguridad, caso fortuito o fuerza mayor, previa comunicación al ganador.
                </Paragraph>
                <Paragraph>
                  Para el ingreso a la sede de Lima, el ganador deberá proporcionar un correo electrónico vigente, en el cual podrá recibir una invitación o código QR. o fuerza mayor, previa comunicación al ganador.
                </Paragraph>
                <Paragraph>
                  Para el ingreso a la sede de Lima, el ganador deberá proporcionar un correo electrónico vigente, en el cual podrá recibir una invitación o código QR. Al momento del recojo deberá presentar su DNI o Carné de Extranjería físico, original y vigente, así como firmar el Acta de Entrega de Premio. La invitación o código QR no reemplaza la presentación del documento de identidad.
                </Paragraph>
                <Paragraph>
                  Bitel contará con un plazo máximo de sesenta (60) días calendario para coordinar y completar la entrega del premio, computado desde el día siguiente de la comunicación individual mediante la cual Bitel confirme expresamente al cliente como ganador, una vez culminado el proceso de validación correspondiente y completada la información necesaria para gestionar la entrega.
                </Paragraph>
                <Paragraph>
                  El premio será entregado personalmente al ganador debidamente validado. Si este no pudiera recogerlo, podrá designar previamente a un representante, quien deberá presentar:
                </Paragraph>
                <Paragraph style={{ paddingLeft: 20 }}>
                  <li>
                    Carta poder legalizada ante Notario Público.
                  </li>
                  <li>
                    Copia del DNI o Carné de Extranjería del ganador.
                  </li>
                  <li>
                    DNI o Carné de Extranjería físico, original y vigente del representante.
                  </li>
                  <li>
                    Cualquier otro dato o documento solicitado previamente por Bitel para validar la representación.
                  </li>
                </Paragraph>
                <Paragraph>
                  Bitel podrá conservar copia de los documentos presentados como sustento de la entrega. La designación del representante no implica la transferencia del premio, sino únicamente su autorización para realizar el recojo en nombre del ganador.
                </Paragraph>
                <Paragraph>
                  Si el ganador no asiste en la fecha pactada, deberá solicitar previamente la reprogramación y contará con los siguientes plazos, computados desde el día siguiente de la primera fecha coordinada:
                </Paragraph>
                <Paragraph style={{ paddingLeft: 20 }}>
                  <li><strong>Lima Metropolitana y Callao:</strong> siete (7) días hábiles.</li>
                  <li><strong>Provincias:</strong> quince (15) días hábiles.</li>
                </Paragraph>
                <Paragraph>
                    La nueva fecha estará sujeta a coordinación y disponibilidad. Vencido el plazo correspondiente sin que se haya completado el recojo, el ganador perderá el derecho a recibir el premio y este retornará al inventario.
                </Paragraph>
                <Paragraph>
                  Los premios son personales, intransferibles, no endosables y no reembolsables. No podrán ser negociados, intercambiados, sustituidos ni canjeados por dinero, saldo, otros productos o beneficios.
                </Paragraph>
                <Paragraph>
                  Una vez entregado el premio y firmada el Acta de Entrega, Bitel no será responsable por daños o desperfectos ocasionados posteriormente por el uso, manipulación, traslado o conservación del producto, sin perjuicio de las garantías y responsabilidades que correspondan conforme a la normativa aplicable.
                </Paragraph>
                <Title level={2}>
                  11. <u>IMPORTANTE</u>
                </Title>
                <Paragraph style={{ paddingLeft: 20 }}>
                  <li>
                    El premio que será el producto a ser subastado en un ciclo
                    definido no es negociable.
                  </li>
                  <li>Las imágenes de los premios son referenciales.</li>
                  <li>
                    Para contactar al Centro de Atención al Cliente de Bitel, el
                    cliente puede llamar al 930123123 desde cualquier operador
                    (con costo), al 123 desde su número Bitel (sin costo) o
                    también puede enviar un email a la dirección electrónica{" "}
                    <Link href="mailto:subasta@arabicatech.vn" underline>
                      subasta@arabicatech.vn
                    </Link>{" "}
                    o a{" "}
                    <Link
                      href="mailto:servicioalcliente@viettelperu.com.pe"
                      underline
                    >
                      servicioalcliente@viettelperu.com.pe
                    </Link>
                  </li>
                </Paragraph>
                <Title level={2}>
                  12.{" "}
                  <u>
                    POLÍTICA DE PRIVACIDAD Y TRATAMIENTO DE DATOS PERSONALES
                  </u>
                </Title>
                <Paragraph>
                  Bitel es una empresa privada que mantiene la privacidad y la
                  protección de información de sus clientes, de conformidad con
                  lo establecido en la Ley No. 29733, Ley de Protección de Datos
                  Personales, su Reglamento y normas complementarias, adoptando
                  para ello las medidas técnicas y organizativas necesarias para
                  evitar la pérdida, mal uso, alteración, acceso no autorizado y
                  robo de los datos personales facilitados por los titulares de
                  datos personales. Asimismo, Bitel garantiza la mejora continua
                  de estas medidas. Bitel, recopila su información personal,
                  tales como nombres completos, correos electrónicos, documentos
                  de identidad; entre otros, que resulten necesarios para
                  cumplir con los fines del Servicio. Dicha recopilación se
                  realiza por medio de formularios físicos, formularios
                  virtuales contenidos en la página web de Bitel, a través de
                  nuestros Call Centers y/o cualquiera de nuestros canales (SMS,
                  pop ups, etc), hasta que se cumplan las finalidades de
                  tratamiento o decida revocar su consentimiento.
                </Paragraph>
                <Paragraph>
                  Bitel cumple con su obligación de poner a disposición del
                  titular de los datos personales toda la información relevante
                  respecto al tratamiento de sus datos personales.
                </Paragraph>
                <Paragraph>
                  Identidad y domicilio del titular de los Bancos de Datos:
                  <li style={{ paddingLeft: 20 }}>
                    Nombre: Viettel Perú S.A.C.
                  </li>
                  <li style={{ paddingLeft: 20 }}>RUC: 20543254798</li>
                  <li style={{ paddingLeft: 20 }}>
                    Domicilio: Calle Veintiuno Nº 878, San Isidro, Lima
                  </li>
                </Paragraph>
                <Paragraph>
                  La información personal que proporcionen los clientes será
                  almacenada en el banco de datos de “CLIENTES” de titularidad
                  de Bitel.
                </Paragraph>
                <Paragraph>
                  Bitel cuenta con todas las medidas técnicas, legales y
                  organizacionales necesarias para garantizar la seguridad y
                  confidencialidad de sus datos personales. Sus datos personales
                  serán tratados considerando los principios de legalidad,
                  consentimiento, proporcionalidad, calidad, seguridad y los
                  demás presentes en la normativa vigente referente a Protección
                  de Datos Personales, evitando que estos sean filtrados,
                  difundidos o cualquier acción que ponga en peligro su
                  información personal.
                </Paragraph>
                <Paragraph>
                  El titular de la información personal (cliente) podrá ejercer,
                  de acuerdo a la ley vigente, los derechos de información,
                  acceso, actualización, inclusión, rectificación, supresión y
                  oposición sobre sus datos personales. Para ello podrá
                  acercarse a cualquier Centro de Atención Bitel, completar el
                  formulario de solicitud y presentarlo.
                </Paragraph>
                <Paragraph>
                  Del mismo modo, puede enviar una comunicación al correo
                  electrónico{" "}
                  <Link href="mailto:solicitudespdp@bitel.com.pe" underline>
                    solicitudespdp@bitel.com.pe,
                  </Link>{" "}
                  adjuntando el formulario que podrá encontrar dándole click
                  aquí:{" "}
                  <Link
                    href="https://bitel.com.pe/ayuda/solicitud-de-acceso-rectificacion-cancelacion-u-oposicion.html"
                    underline
                  >
                    https://bitel.com.pe/ayuda/solicitud-de-acceso-rectificacion-cancelacion-u-oposicion.html.
                  </Link>{" "}
                  En ambos casos, el cliente deberá adjuntar la siguiente
                  documentación:
                </Paragraph>

                <Paragraph style={{ paddingLeft: 20 }}>
                  <li>
                    Copia simple y legible del Documento Nacional de Identidad.
                  </li>
                  <li>
                    Copia simple y legible de la Vigencia de Poder Especial, en
                    caso de representación.
                  </li>
                  <li>
                    Documentos que sustenten la solicitud, de ser el caso.
                  </li>
                </Paragraph>
                <Paragraph>
                  Bitel se reserva el derecho de modificar y/o actualizar la
                  presente Política de Privacidad como parte de su mejora
                  continua, ya sea para adaptarla a futuros cambios normativos,
                  brindar una mejor calidad del Servicio o comunicar nuevas
                  alternativas relacionadas a la presente Política.
                </Paragraph>
                <Paragraph>
                  Podrás conocer más sobre nuestra política de protección de
                  datos y privacidad aquí:{" "}
                  <Link href={PATHS.POLICY_PAGE} underline>
                    {PATHS.POLICY_PAGE}
                  </Link>
                </Paragraph>
                <Title level={2}>
                  13. <u>CESIÓN DE DERECHOS DE DATOS PERSONALES</u>
                </Title>
                <Paragraph>
                  El participante reconoce expresamente que, de ser elegido
                  ganador, otorga el derecho irrevocable a Bitel a ceder a
                  título gratuito: sus nombres y apellidos completos, lugar de
                  residencia, voz e imagen, para que estos aparezcan en las
                  publicaciones, medios publicitarios y, en general, en todo
                  material de divulgación de las actividades del concurso; como
                  entrega, recibo y disfrute del premio, testimoniales, ya sea
                  durante el plazo promocional o una vez vencido el mismo, sin
                  que implique el derecho a recibir contraprestación alguna, ni
                  generar reclamos por derechos de imagen y/o voz, los cuales
                  serán cedidos sólo para efectos de divulgación de los
                  resultados y acreditación del premio.
                </Paragraph>
                <Title level={2}>
                  14.{" "}
                  <u>
                    EXENCIÓN DE RESPONSABILIDAD POR CONTENIDO ALOJADO EN
                    “SUBASTAS” Y POR USO DEL SERVICIO
                  </u>
                </Title>
                <Paragraph>
                  Los contenidos alojados en Subastas por fotos, información o
                  cualquier otro contenido al cual los usuarios pueden acceder,
                  no son controlados por Bitel. Por lo que, en ningún caso Bitel
                  se hace responsable de ellos.
                </Paragraph>
                <Paragraph>
                  Bitel se excluye de cualquier responsabilidad por los daños y
                  perjuicios de toda naturaleza que puedan derivarse del acceso
                  al Servicio, que sean contrarios a la ley, moral, la buena fe
                  y al orden público, infrinjan derechos de propiedad
                  intelectual, industrial o contengan cualquier vicio, defecto,
                  virus informático o similar.
                </Paragraph>
                <Paragraph>
                  Bitel no resulta responsable por el mal uso que realice el
                  usuario del Servicio, siendo esto de responsabilidad exclusiva
                  de quien acceda al contenido y lo utilice.
                </Paragraph>
                <Paragraph>
                  Bitel no se hace responsable por el uso indebido de las claves
                  de acceso de los usuarios para el Servicio y, de las
                  consecuencias derivadas de cualquier naturaleza del mal uso
                  por los usuarios, su pérdida u olvido y su uso indebido por
                  tercero no autorizado.
                </Paragraph>
                <Title level={2}>
                  15. <u>JURISDICCIÓN Y COMPETENCIA</u>
                </Title>
                <Paragraph>
                  Toda relación que se genere entre el cliente y el Servicio se
                  regirá a las leyes Peruanas y podrá someterse a los Tribunales
                  y Jueces del Distrito de Lima. Renunciando el cliente a
                  cualquier otra ley a cuya aplicación pudiere tener derecho.
                  Las partes renuncian expresamente a cualquier otra
                  jurisdicción que pudiera corresponder.
                </Paragraph>
              </Typography>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TermsPage;
